import { graphql } from 'graphql-schema';
/** For daily views, we only show the top seven sports. */
export const DISCOVER_DAILY_TOP_SPORTS_LIMIT = 7;
export const DISCOVER_TOP_SPORTS_QUERY = graphql(`
  query TopSports($where: sports_bool_exp!, $order_by: sports_order_by!, $limit: Int) {
    sports(where: $where, order_by: [$order_by], limit: $limit) {
      _id
      name
    }
  }
`);
export const formatDiscoverTopSportsVariables = ({ isRental, programTypes, organizationId, organizationName, }) => {
    return {
        order_by: isRental
            ? { rentals_aggregate: { count: 'desc' } }
            : { leagues_aggregate: { count: 'desc' } },
        where: isRental
            ? {
                rentals: {
                    is_discoverable: { _eq: true },
                    ...(organizationName
                        ? { organizationByOrganization: { name: { _eq: organizationName } } }
                        : {}),
                    ...(organizationId ? { organization: { _eq: organizationId } } : {}),
                },
            }
            : {
                leagues: {
                    private: { _eq: false },
                    archived: { _eq: false },
                    status: { _eq: 'registration_open' },
                    ...(organizationName
                        ? { organizationByOrganization: { name: { _eq: organizationName } } }
                        : {}),
                    ...(organizationId ? { organization: { _eq: organizationId } } : {}),
                    ...(programTypes?.length ? { program_type: { _in: programTypes } } : {}),
                },
            },
    };
};
